import React from 'react';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Checkbox from '@visa/vds/checkbox';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';

function AnnouncementRegionSelection(props) {
    return(
        <>
        <Row noGutter key={3}>
            <Col noTopGutter noGutter lg={2}>
                <CheckboxList>
                    <CheckboxListItem>
                        <Checkbox
                            checked={props.announcement.us} onChange={props.toggleUs}
                            id={"us"} label={"US"}
                            name="checkbox-us"
                        />
                    </CheckboxListItem>
                </CheckboxList>
            </Col>
            <Col noTopGutter noGutter lg={2}>
                <CheckboxList>
                    <CheckboxListItem>
                        <Checkbox
                            checked={props.announcement.canada} onChange={props.toggleCanada}
                            id={"canada"} label={"Canada"}
                            name="checkbox-canada"
                        />
                    </CheckboxListItem>
                </CheckboxList>
            </Col>
            <Col noTopGutter noGutter lg={2}>
                <CheckboxList>
                    <CheckboxListItem>
                        &emsp;
                        <Checkbox
                            checked={props.announcement.eu} onChange={props.toggleEu}
                            id={"eu"} label={"EU"}
                            name="checkbox-eu"
                        />
                    </CheckboxListItem>
                </CheckboxList>
            </Col>                               
            <Col noTopGutter noGutter lg={2}>
                <CheckboxList>
                    <CheckboxListItem>
                        <Checkbox
                            checked={props.announcement.ap} onChange={props.toggleAp}
                            id={"ap"} label={"AP"}
                            name="checkbox-ap"
                        />
                    </CheckboxListItem>
                </CheckboxList>
            </Col>
            <Col noTopGutter noGutter lg={2}>
                <CheckboxList>
                    <CheckboxListItem>
                        <Checkbox
                            checked={props.announcement.lac} onChange={props.toggleLac}
                            id={"lac"} label={"LAC"}
                            name="checkbox-lac"
                        />
                    </CheckboxListItem>
                </CheckboxList>
            </Col>
            <Col noTopGutter noGutter lg={2}>
                <CheckboxList>
                    <CheckboxListItem>
                        <Checkbox
                            checked={props.announcement.cemea} onChange={props.toggleCemea}
                            id={"cemea"} label={"CEMEA"}
                            name="checkbox-cemea"
                        />
                    </CheckboxListItem>
                </CheckboxList>
            </Col>
        </Row>
        
        </>
    );
}

export default AnnouncementRegionSelection